import { svgPathStyles } from "@digits-shared/components/SVG/svgIconStyles"
import colors from "@digits-shared/themes/colors"
import fonts from "@digits-shared/themes/typography"
import styled, { css } from "styled-components"

export const ApplicationTitleContainer = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  position: relative;
`

export const ApplicationIconStyles = css`
  height: 24px;
  width: 24px;
  display: block;
  ${svgPathStyles(colors.white, 1.5)};
`

export const ApplicationTitle = styled.div`
  ${fonts.scale.h2};
  font-weight: ${fonts.weight.heavy};
  display: flex;
  align-items: center;
  gap: 8px;

  & > svg {
    ${ApplicationIconStyles};
  }
`
